module.exports = "textarea {\n    resize: none;\n}\n\n.btn.procedureOption {\n    margin-top: 22px;\n}\n\ninput[type=\"file\"] {\n    display: none;\n}\n\n.custom-file-upload {\n    border: 1px solid #ccc;\n    display: inline-block;\n    padding: 6px 12px;\n    cursor: pointer;\n    background-color: #337ab7;\n    color: white;\n    border-radius: 4px;\n}\n\nh3.titleUploader {\n    margin-top: 0;\n}\n\n.cortar {\n    width: 10%;\n    overflow:hidden;\n    white-space:nowrap;\n    text-overflow: ellipsis\n}\n\n.cortar:active {\n    overflow:visible;\n    white-space: initial;\n    cursor: pointer;\n}"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/procedures/procedures.editor.component.css
 ** module id = 1112
 ** module chunks = 0
 **/